<template>
    <a v-if="display" :href="url" class="apply-button">
        <div class="button-copy">
            {{ text }}
        </div>
    </a>
</template>

<script>
    export default {
        name: "ApplyButton",
        props: {
            display: Boolean,
            text: String,
            url: String
        }
    }
</script>

<style lang="scss" scoped>

    .apply-button {
        z-index: 999;
        display: flex;
        align-items: center;
        justify-content: center;
        color: $white;
        text-decoration: none;
        text-transform: uppercase;
        font-size: 12px;
        height: 50px;
        padding: 15px;
        width: 180px;
        transition: all 500ms;
        @include orange-hover;

        @media (max-width: 1120px) {
            height: 45px;
            width: 150px;
        }

        @media (max-width: 400px) {
            height: 45px;
            padding: 15px 0;
            width: 85px;
        }
    }

</style>